const en = {
  header: {
    about: "ABOUT US",
    artist: "ARTIST",
    services: "SERVICES",
    contact: "CONTACT US",
    whatsapp: "WHATSAPP"
  },
  home: {
    welcomeTitle: "Kellink Tattoo",
    welcomeText: "Welcome to our studio where passion meets precision",
    browserUnsupported: "Your browser does not support the video tag."
  },
  about: {
    title: "We are",
    highlight: "Kellink Tattoo",
    description: "Welcome to Kellink Tattoo's premier tattoo studio! We are passionate artists dedicated to creating unique and meaningful tattoos that tell your story. With years of experience in various styles and techniques, we pride ourselves on delivering exceptional artistry in a clean, professional environment. Our commitment to quality and attention to detail ensures that each tattoo we create is a masterpiece that will last a lifetime."
  },
  artist: {
    sectionTitle: "Artist",
    name: "Conlitchenko Gabriel",
    title: "Professional Tattoo Artist",
    bio: "With a passion for creating beautiful, meaningful tattoos, I specialize in creating designs that tell your personal story. My approach combines artistic vision with technical precision to create tattoos that stand the test of time.",
    specialtiesTitle: "Specialties",
    specialties: ["Realistic", "Black & Gray", "Traditional", "Custom Designs"],
    experienceTitle: "Experience",
    experienceText: "Over 10 years of professional tattooing experience, continuously refining techniques and exploring new artistic directions.",
    ctaButton: "BOOK A CONSULTATION"
  },
  gallery: {
    title: "Our Gallery",
    subtitle: "View our latest creations and artistic styles",
    viewButton: "VIEW FULL",
    backButton: "BACK",
    navigationPrev: "Previous",
    navigationNext: "Next",
    closeModal: "Close",
    visitLink: "Visit design page",
    instagram: "Follow on Instagram",
    facebook: "Like on Facebook",
    zoomImage: "Zoom image"
  },
  services: {
    title: "Our Services",
    intro: "We offer a comprehensive range of tattoo services to suit every style and preference. Our experienced artists specialize in various techniques and designs, ensuring you receive the highest quality artwork that perfectly expresses your vision.",
    serviceCards: [
      {
        title: "Custom Tattoo Design",
        description: "Unique, personalized tattoo designs created specifically for you. We take your ideas and transform them into original artwork that reflects your personality and style. Each design is crafted with attention to detail and artistic excellence."
      },
      {
        title: "Traditional & Neo-Traditional",
        description: "Bold lines, vibrant colors, and timeless imagery characterize our traditional tattoo styles. From classic sailor designs to modern interpretations, our artists are skilled in creating beautiful, long-lasting traditional pieces."
      },
      {
        title: "Realism & Portrait Tattoos",
        description: "Lifelike tattoos that capture extraordinary detail and dimension. Our realism specialists create stunning portraits, nature scenes, and photorealistic imagery that looks like it could come to life on your skin."
      },
      {
        title: "Cover-Ups & Reworks",
        description: "Transform old, faded, or unwanted tattoos into beautiful new designs. Our artists are experts at creating cover-up tattoos that completely conceal previous work while creating something new that you'll love for years to come."
      }
    ]
  },
  contact: {
    subtitle: "FANCY A CHAT? GET IN TOUCH.",
    title: "Let's talk, meet, work together.",
    formTitle: "Get in touch.",
    formLabels: {
      name: "Name",
      phone: "Phone",
      email: "Email",
      instagram: "Instagram",
      message: "Message"
    },
    submitButton: "SUBMIT"
  },
  footer: {
    companyName: "Kellink Tattoo S.R.L.",
    navigation: "Navigation",
    contact: "Contact",
    followUs: "Follow us",
    copyright: "All rights reserved.",
    links: {
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    }
  },
  language: {
    en: "English",
    ro: "Romanian"
  }
};

export default en; 